import { render, staticRenderFns } from "./secretary-info.vue?vue&type=template&id=75a6dc74&scoped=true&"
import script from "./secretary-info.vue?vue&type=script&lang=js&"
export * from "./secretary-info.vue?vue&type=script&lang=js&"
import style0 from "./secretary-info.vue?vue&type=style&index=0&id=75a6dc74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a6dc74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressLinear,VRow})
